import { createContext, useContext } from "react";
import { useState } from "react";

const TopMenuContext = createContext()
export const useTopMenuOpen = () => useContext(TopMenuContext)

export function TopMenuProvider({ children }) {
    const [isTopMenuOpen, setIsTopMenuOpen] = useState(false)
    const changeTopMenu = () => setIsTopMenuOpen(!isTopMenuOpen)
    const closeTopMenu= () => setIsTopMenuOpen(false)
    return (
        <TopMenuContext.Provider value={[isTopMenuOpen, changeTopMenu, closeTopMenu]}>
            {children}
        </TopMenuContext.Provider>
    )
}